import { render, staticRenderFns } from "./SidepanelHelp.vue?vue&type=template&id=d570f4ba&"
import script from "./SidepanelHelp.vue?vue&type=script&lang=js&"
export * from "./SidepanelHelp.vue?vue&type=script&lang=js&"
import style0 from "./SidepanelHelp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports